import { z } from 'zod'
import { hostName } from './format';
import { BuildMetaDeps } from './seo';

export const searchProduct = (search: Record<string, unknown>)=>{
  return z.object({
    search: z.string().catch(''),
    areaRange: z.string().catch(''),
    categoryId: z.string().catch(''),
    priceRange: z.string().catch(''),
    provinceId: z.string().catch(''),
  }).parse(search)
}
export function buildQueryString(values: any): string {
  const params = new URLSearchParams();

  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, value.toString());
    }
  });

  return params.toString();
}
export const prefer = (...c: Array<string | null | undefined>) =>
  c.map(clean).find(Boolean);
export const absImage = (hostName: BuildMetaDeps["hostName"], path?: string | null) =>
  path ? hostName(path) : undefined;

export const clean = (s?: string | null) =>
  typeof s === "string" ? s.replace(/\s+/g, " ").trim() : undefined;
